_ = require('underscore');
module.exports = {
    "filter": function(obj) {
var __t, __p = '';
__p += '\n    <div class="favorite-search-filter-label" data-tn="favorite-search-filter-label">' +
((__t = ( obj.label )) == null ? '' : __t) +
'</div>\n    <div class="favorite-search-filter-value" data-tn="favorite-search-filter-value">' +
((__t = ( obj.value )) == null ? '' : __t) +
'</div>\n';
return __p
},
    "confirmationTooltip": function(obj) {
var __t, __p = '';
__p += '\n    <div class="favorite-confirmation-content" data-tn="favorite-confirmation-tooltip">' +
((__t = ( obj.copy )) == null ? '' : __t) +
'</div>\n';
return __p
},
    "ctaTooltip": function(obj) {
var __t, __p = '';
__p +=
((__t = ( obj.copy )) == null ? '' : __t);
return __p
},
    "ctaMomentumTooltip": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="dibstooltip-momentum-title" data-tn="cta-momentum-tooltip-title">' +
((__t = ( obj.title )) == null ? '' : __t) +
'</div>\n    <div class="dibstooltip-momentum-content" data-tn="cta-momentum-tooltip-content">' +
((__t = ( obj.content )) == null ? '' : __t) +
'</div>\n\n    ';
 if (obj.closeIcon) { ;
__p += '\n        <a class="js-close-tooltip dibstooltip-momentum-close" href="#" data-tn="cta-momentum-tooltip-close">\n            ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n        </a>\n    ';
 } ;
__p += '\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/templates/favorites/searches.html
// module id = 2774
// module chunks = 63